/* eslint-disable prefer-regex-literals */
import { LANDING_PAGE_DOMAIN } from '@/services/constants';
import { HideDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import {
    AddLandingPageAccountSubdomain,
    getAccountLandingPageSubdomain,
    LoadLandingPageSubdomain,
} from '@/store/landingPageSubdomain/actions';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useAccessLevel } from '@/services/hooks/useAccessLevel';
import { getAccountAccessLevel } from '@/store/account/actions';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { AddLandingPageSubdomainDialogBody } from './components/AddLandingPageSubdomainDialogBody';

export const validationRegEx = new RegExp(/^[a-zA-Z0-9-]*$/);

const MAX_DOMAIN_LENGTH = 63;

export const useAddLandingPageSubdomainDialog = () => {
    const { t } = useTranslation();
    const al = useSelector(getAccountAccessLevel);
    const currentSubdomain = useSelector(getAccountLandingPageSubdomain);
    
    const [inputValue, setInputValue] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const dispatch = useDispatch<any>();

    useEffect(() => {
        if (currentSubdomain || !al?.includes?.(AccessLevel.ModifyLandingPages)) return;
        dispatch(LoadLandingPageSubdomain());
    }, []);

    const validateAndChange = (e) => {
        setErrorMsg('');
        const newValue = e?.target?.value;
        if (newValue?.length > MAX_DOMAIN_LENGTH || !isValidInput(newValue)) return;
        // setInputValue(newValue);
        setInputValue(newValue);
    };

    const isValidInput = (value = inputValue) => validationRegEx.test(value);

    const saveOrUpdateSubdomain = () => {
        if (!isValidInput()) return;
        dispatch(AddLandingPageAccountSubdomain(inputValue))
            .then(() => {
                dispatch(HideDialog());
            })
            .catch(({ errorKey }) => {
                const mappedErrors = {
                    landing_subdomain_in_use: t('landing_subdomain_in_use'),
                    landing_subdirectory_in_use: t('landing_subdirectory_in_use'),
                    landing_invalid_suffix: t('landing_invalid_suffix'),
                };
                setErrorMsg(mappedErrors[errorKey]);
            });
    };

    const getConfig = () =>
        ({
            body: (
                <AddLandingPageSubdomainDialogBody
                    subdomain={inputValue}
                    errorMsg={errorMsg}
                    onChange={validateAndChange}
                />
            ),
            title: t('addsubdomain'),
            confirmLabel: t('save'),
            cancelLabel: t('cancel'),
            onClickConfirm: (): void => {
                saveOrUpdateSubdomain();
            },
            onClickCancel: () => {
                setInputValue('');
            },
            fullScreen: false,
            isHiddenManually: true,
            isDisabled: !inputValue,
        } as ShowDialogParams);

    return { getConfig };
};
